export default __webpack_public_path__ + "static/media/future.11a8e0fe.svg";